export default "__VITE_ASSET__DeVMXg3x__"